

































import { defineComponent, PropType } from '@vue/composition-api'
import DateTimePicker from '~/components/DateTimePicker.vue'
import { VueForm } from '~/utils/interfaces'
import { CreateCarBooking } from '~/utils/interfaces/rentalCar'
import vRules from '~/utils/vRules'

export default defineComponent({
  components: { DateTimePicker },
  props: {
    crud: {
      type: Object as PropType<CreateCarBooking>,
      required: true,
    },
  },
  data() {
    return {
      vRules,
    }
  },
  methods: {
    onNext() {
      return (this.$refs.form as VueForm).validate()
    },
  },
})
